import { Tab, TabProps, Tooltip } from '@material-ui/core';
import React from 'react';

interface TabWithTooltipProps extends TabProps {
  tooltip: string;
}

export const TabWithTooltip: React.FC<TabWithTooltipProps> = ({
  tooltip,
  ...props
}: TabWithTooltipProps) => {
  return (
    tooltip ? (
      <Tooltip title={tooltip}>
        <Tab {...props} />
      </Tooltip>
    ) : (
      <Tab {...props} />
    )
  )
};
